<template>
    <div class="col-12">
        <div class="form-group row">
            <label class="col-sm-3">{{ $t('managerForm.settingPage.pageTypeB.display') }}</label>
            <div class="col-sm-8">
                <div class="d-flex" style="gap: 0.5rem">
                    <InputCheckBox
                        :model.sync="initDrawForm.extension.display_btn_skip"
                        label=""
                        :value="initDrawForm.extension.display_btn_skip"
                        @change="onChangeDisplayBtnSkip"
                    />
                </div>
                <p v-if="!initDrawForm.extension.display_btn_skip">
                    ※「結果画面遷移ボタン表示する」にチェックを入れない場合、「設定項目追加」に表示用ブロック１を追加し、注記を表示する形で対応可能です。
                </p>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3"
                >{{
                    initDrawForm.extension.display_btn_skip
                        ? $t('managerForm.settingPage.pageTypeB.buttonValidTime')
                        : $t('managerForm.settingPage.pageTypeB.automaticRedirect')
                }}
                <span v-if="onHandleCheckFieldRequired(configDrawFormB.extension.automatic_redirect_after.typesValidate)" class="text-danger"
                    >*</span
                ></label
            >
            <div class="col-sm-8">
                <div class="d-flex" style="gap: 0.5rem">
                    <InputText
                        :model.sync="initDrawForm.extension.automatic_redirect_after"
                        :config.sync="configDrawFormB.extension.automatic_redirect_after"
                        @blur="onHandleValid(initDrawForm.extension.automatic_redirect_after, configDrawFormB.extension.automatic_redirect_after)"
                    />
                    <span class="mt-2">{{ $t('managerForm.settingPage.pageTypeB.seconds') }}</span>
                </div>
                <p v-if="initDrawForm.extension.display_btn_skip" class="mt-2">※抽選画面上のボタンを有効化するまでの秒数を設定するためのものです。</p>
                <p v-else class="mt-2">※当落画面へ自動的に遷移するまでの秒数を設定するためのものです。</p>
            </div>
        </div>
        <div v-if="initDrawForm.extension.display_btn_skip" class="form-group row">
            <label class="col-sm-3"
                >{{ $t('managerForm.settingPage.pageTypeB.skipButton') }}
                <span v-if="onHandleCheckFieldRequired(configDrawFormB.extension.btn_skip.typesValidate)" class="text-danger">*</span></label
            >
            <div class="col-sm-8">
                <InputText
                    :model.sync="initDrawForm.extension.btn_skip"
                    :config.sync="configDrawFormB.extension.btn_skip"
                    @blur="onHandleValid(initDrawForm.extension.btn_skip, configDrawFormB.extension.btn_skip)"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { InputText, InputCheckBox } from '@/components/Input';
import { validateField } from '@/utils/validate_v2';
import { onHandleCheckFieldRequired } from '@/utils/handlers';

export default {
    name: 'SettingSerial',
    components: {
        InputText,
        InputCheckBox
    },
    props: {
        formDrawInit: {
            type: Object,
            required: true,
            default: () => null
        },
        configDrawFormB: {
            type: Object,
            default: () => null
        },
        typeSettingScreen: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            initDrawForm: {
                extension: {}
            }
        };
    },
    methods: {
        onHandleCheckFieldRequired,
        onHandleValid(valueField, configField) {
            validateField(valueField, configField);
        },

        getDataFormDraw() {
            return JSON.parse(JSON.stringify(this.initDrawForm));
        },
        resetDataFormDraw() {
            this.initDrawForm = JSON.parse(JSON.stringify(this.formDrawInit));
        },
        onChangeDisplayBtnSkip(val) {
            if (val) {
                this.initDrawForm.extension.automatic_redirect_after = 10;
                this.configDrawFormB.extension.automatic_redirect_after.errorField = this.$t('managerForm.settingPage.pageTypeB.buttonValidTime');
            } else {
                this.initDrawForm.extension.automatic_redirect_after = 3;
                this.configDrawFormB.extension.automatic_redirect_after.errorField = this.$t('managerForm.settingPage.pageTypeB.automaticRedirect');
            }
        }
    },

    watch: {
        formDrawInit: {
            handler: function (newVal) {
                this.initDrawForm = JSON.parse(JSON.stringify(newVal));
            },
            immediate: true,
            deep: true
        }
    }
};
</script>
